"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getRequirementSetsByCustomerId = exports.getAllCustomers = exports.getProfilesByCustomerId = exports.getCheckinUrlsByCustomerId = exports.getDepartureServicesById = exports.getCustomersById = exports.getDepartureServiceIds = exports.getCustomerIds = undefined;

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _keys = require("babel-runtime/core-js/object/keys");

var _keys2 = _interopRequireDefault(_keys);

var _lodash = require("lodash");

var _lodash2 = _interopRequireDefault(_lodash);

var _reselect = require("reselect");

var _forms = require("utils/forms");

var _utilityFunctions = require("utils/utilityFunctions");

var _REQUIREMENT_SET_CODES = require("metadata/REQUIREMENT_SET_CODES");

var _REQUIREMENT_SET_CODES2 = _interopRequireDefault(_REQUIREMENT_SET_CODES);

var _utils = require("./utils/mappings/utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getBookingId = function getBookingId(state) {
    return state.booking.id;
};

// May or may not contain complete resources (see getCompleteResourcesByIdFactory)
var getPartialCustomersById = function getPartialCustomersById(state) {
    return state.customers;
};
var getPartialDepartureServicesById = function getPartialDepartureServicesById(state) {
    return state.departureServices;
};

var getIdsFactory = function getIdsFactory(resourcesByIdSelector) {
    return (0, _reselect.createSelector)([resourcesByIdSelector], _keys2.default);
};
var getCustomerIds = exports.getCustomerIds = getIdsFactory(getPartialCustomersById);
var getDepartureServiceIds = exports.getDepartureServiceIds = getIdsFactory(getPartialDepartureServicesById);

// Only returns resources with all required fields listed
var getCompleteResourcesByIdFactory = function getCompleteResourcesByIdFactory(resourcesByIdSelector, requiredFields) {
    return (0, _reselect.createSelector)([resourcesByIdSelector], function (resourcesById) {
        return (0, _keys2.default)(resourcesById).reduce(function (obj, resourceId) {
            var resource = resourcesById[resourceId];
            if (requiredFields.every(function (field) {
                return (0, _utilityFunctions.getResourceValue)(field, resource);
            })) {
                obj[resourceId] = resource;
            }
            return obj;
        }, {});
    });
};
// Returns each customer (by id) that contains the required fields
var getCustomersById = exports.getCustomersById = getCompleteResourcesByIdFactory(getPartialCustomersById, ["name.legal_first_name", "name.legal_last_name"]);
// Returns each departure service (by id) that contains the required fields
var getDepartureServicesById = exports.getDepartureServicesById = getCompleteResourcesByIdFactory(getPartialDepartureServicesById, ["name", "start_date", "finish_date"]);

var getCheckinUrlsByCustomerId = exports.getCheckinUrlsByCustomerId = function getCheckinUrlsByCustomerId(state) {
    return state.checkinUrls;
};

var getProfilesByCustomerId = exports.getProfilesByCustomerId = function getProfilesByCustomerId(state) {
    return state.profiles;
};

// Gets requirements with values/tempIds/hrefs of their resource (from normalizr in fetchRequirementData.js)
var getRequirementsByHash = function getRequirementsByHash(state) {
    return state.requirements;
};

var getRequirementSetsByCode = function getRequirementSetsByCode(state) {
    return state.requirementSets;
};

var getLinkedBookingsCustomers = function getLinkedBookingsCustomers(state) {
    return state.booking.linkedBookingsCustomers;
};

// Return requirement sets array in order defined in REQUIREMENT_SET_CODES
// (if no requirement set is found for a code, it is omitted from the array)
var getRequirementSets = (0, _reselect.createSelector)([getRequirementSetsByCode], function (requirementSetsByCode) {
    return _REQUIREMENT_SET_CODES2.default.reduce(function (arr, requirementSetCode) {
        var requirementSet = requirementSetsByCode[requirementSetCode];
        if (requirementSet) {
            arr.push(requirementSet);
        }
        return arr;
    }, []);
});

// Some requirements can be non-unique for one customer and one requirement set
// Identify these cases and store them as arrays under the same requirement code key
var storeAsArrayReqCodes = ["ARRIVAL_FLIGHT_DETAILS", "DEPARTURE_FLIGHT_DETAILS", "GALAPAGOS_BOAT_CHANGE", "HOTEL_CHANGE_ACKNOWLEDGEMENT", "ITINERARY_CHANGE", "LIABILITY_WAIVER", "LIABILITY_WAIVER_KAYAKING", "LIABILITY_WAIVER_CAMPING", "ODD_NUMBER_OF_TRAVELLERS", "PARTICIPATION_WAIVER", // not actually necessary, but makes our life easier in Waiver.js
"SERVICE_GAP_ACKNOWLEDGEMENT", "UNUSUAL_START_END_TIME", "ROOMING_DETAILS", "TRAVELLING_WITH_MINORS"];

var getAllCustomers = exports.getAllCustomers = (0, _reselect.createSelector)([getCustomersById, getLinkedBookingsCustomers], function (customersById, linkedBookingCustomers) {
    var customers = (0, _extends3.default)({}, customersById);
    if (linkedBookingCustomers) {
        (0, _keys2.default)(linkedBookingCustomers).map(function (key) {
            customers[key] = linkedBookingCustomers[key];
        });
    }
    return customers;
});

// Returns object of customerIds containing an array of requirement sets,
//  each set containing an array of requirements
// Object of customerIds also contains an object of requirement sets (with codes for keys)
//  each also containing an object of requirements (with codes for keys)
var getRequirementSetsByCustomerId = exports.getRequirementSetsByCustomerId = (0, _reselect.createSelector)([getBookingId, getRequirementSets, getRequirementsByHash, getCustomerIds, getProfilesByCustomerId, getDepartureServicesById], function (bookingId, requirementSets, requirementsByHash, customerIds, profilesByCustomerId, departureServicesById) {
    // Generate customersById object to be filled
    var customersById = customerIds.reduce(function (obj, customerId) {
        obj[customerId] = {
            reqSetsByCode: {},
            reqSets: [],
            totalReqSets: 0,
            reqSetsComplete: 0
        };
        return obj;
    }, {});

    // Fill customersById object with requirement sets with their requirements and initialValues for each set's form
    requirementSets.forEach(function (requirementSet, reqSetIndex) {
        customerIds.forEach(function (customerId) {
            customersById[customerId].reqSetsByCode[requirementSet.code] = (0, _extends3.default)({}, requirementSet, {
                reqsByCode: {},
                initialValues: {},
                hiddenValues: {}
            });
            customersById[customerId].reqSets.push((0, _extends3.default)({}, requirementSet, {
                totalReqs: 0,
                reqsComplete: 0
            }));

            // Add initialValues for profile resource
            // (if customer does not have access to it, it will be undefined)
            var customerProfile = profilesByCustomerId[customerId];
            if (customerProfile && customerProfile.href) {
                customersById[customerId].reqSetsByCode[requirementSet.code].initialValues[customerProfile.href] = customerProfile;
            }
        });

        requirementSet.requirements.forEach(function (requirementHash) {
            var requirement = requirementsByHash[requirementHash];
            var custRequirementSet = customersById[requirement.customer].reqSetsByCode[requirementSet.code];

            // Check if requirement should be stored by itself or in an array
            if (storeAsArrayReqCodes.includes(requirement.code)) {
                if (custRequirementSet.reqsByCode[requirement.code]) {
                    custRequirementSet.reqsByCode[requirement.code].push(requirement);
                } else {
                    custRequirementSet.reqsByCode[requirement.code] = [requirement];
                }
            } else {
                custRequirementSet.reqsByCode[requirement.code] = requirement;
            }

            // Generate initialValues for the requirement set
            // (the form needs the requirement's values unflattened for the whole requirement set)

            // to PATCH
            var initialValues = custRequirementSet.initialValues;
            var hiddenValues = custRequirementSet.hiddenValues;

            (0, _keys2.default)(requirement.fieldValuesByResourceType).forEach(function (resourceType) {
                var resourceFields = requirement.fieldValuesByResourceType[resourceType];
                var resourceHref = requirement.fieldResourceHrefsByType[resourceType];

                if (resourceType === "overrides") {
                    initialValues[resourceHref] = resourceFields;
                } else {
                    (0, _keys2.default)(resourceFields).forEach(function (fieldPath) {
                        var resourceFieldValue = resourceFields[fieldPath].value;
                        var resourceFieldValueHidden = resourceFields[fieldPath].value_hidden;

                        // .[] values need to be smushed together in the same array value
                        var preExistingVal = initialValues[resourceHref] && initialValues[resourceHref][fieldPath];
                        if (preExistingVal && _lodash2.default.isArray(preExistingVal)) {
                            initialValues[resourceHref][fieldPath] = preExistingVal.concat(resourceFieldValue);
                        } else {
                            initialValues[resourceHref] = (0, _utilityFunctions.setResourceValue)(fieldPath, initialValues[resourceHref], resourceFieldValue);
                        }
                        hiddenValues[resourceHref] = (0, _utilityFunctions.setResourceValue)(fieldPath, hiddenValues[resourceHref], resourceFieldValueHidden);
                    });

                    // Flights (we need these to be initialized for PATCHes,
                    //  and ignore superfluous segments data)
                    if (resourceType === "flight_statuses") {
                        // grab segments data parsed from /requirements
                        var flightSegments = initialValues[resourceHref].segments;

                        // Initialize flight with requirement data and stuff we don't get back from /requirements
                        initialValues[resourceHref] = (0, _forms.generateInitialResourceValue)({
                            requirement: requirement,
                            resourceType: resourceType,
                            initialValues: initialValues
                        });
                        // move over only important segments data
                        // (extra data causes issues when trying to PATCH)
                        initialValues[resourceHref].segments = flightSegments.map(function (segment) {
                            return {
                                airline: { code: segment.airline.code },
                                departure_airport: {
                                    code: segment.departure_airport.code
                                },
                                departure_datetime_local: segment.departure_datetime_local,
                                flight_number: segment.flight_number
                            };
                        });
                    }
                }
            });
            // to POST
            // TODO: don't initialize overrides that will never exist...
            (0, _keys2.default)(requirement.toPostTempIdsByResourceType).forEach(function (resourceType) {
                (0, _forms.initializeResourceValue)({
                    requirement: requirement,
                    resourceType: resourceType,
                    bookingId: bookingId,
                    initialValues: initialValues,
                    departureServicesById: departureServicesById
                });
            });

            customersById[requirement.customer].reqSets[reqSetIndex].totalReqs++;
            if (requirement.status === "COMPLETE") {
                customersById[requirement.customer].reqSets[reqSetIndex].reqsComplete++;
            }
        });
    });

    // Determine: which sets are complete, by how much, and if they've completed each of their sets
    customerIds.forEach(function (customerId) {
        var customer = customersById[customerId];
        // We have to go backwards to enable us to splice out empty reqSets from the array
        for (var i = customer.reqSets.length - 1; i >= 0; i--) {
            var reqSet = customer.reqSets[i];
            // Skip (remove) ROOMING_INFORMATION entirely if it's "my own room"
            if (reqSet.code === 'ROOMING_INFORMATION' && (0, _utils.hasMyOwnRoom)(customer)) {
                delete customer.reqSetsByCode[reqSet.code];
                customer.reqSets.splice(i, 1);
                continue;
            }
            if (reqSet.totalReqs === 0) {
                delete customer.reqSetsByCode[reqSet.code];
                customer.reqSets.splice(i, 1);
            } else {
                customer.totalReqSets++;

                if (reqSet.reqsComplete === reqSet.totalReqs) {
                    customer.reqSetsComplete++;
                    customer.reqSetsByCode[reqSet.code].isComplete = true;
                }
            }
        }
    });
    return customersById;
});


//////////////////
// WEBPACK FOOTER
// ./app/selectors.js
// module id = 44
// module chunks = 0